<template>
    <ShortcutsOverview :show="show" :groups="groups" :heading="heading" :close-label="closeLabel" @close="emit('close')" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { onKeyStroke } from '@vueuse/core';
import ShortcutsOverview, { type ShortcutsGroup } from '@src/Common/Components/UI/ShortcutsOverview.vue';
import type { ShortcutDescriptor } from '@src/Common/Composables/useKeyboardShortcuts';

const props = withDefaults(
    defineProps<{
        show: boolean;
        descriptors: ShortcutDescriptor[];
        labels?: Record<string, string>;
        heading?: string;
        closeLabel?: string;
    }>(),
    {
        labels: () => ({}),
        heading: 'Klávesové zkratky',
        closeLabel: 'Zavřít',
    },
);

const emit = defineEmits<{ close: [] }>();

const groups = computed<ShortcutsGroup[]>(() => {
    const map = new Map<string, ShortcutDescriptor[]>();
    for (const descriptor of props.descriptors) {
        const bucket = map.get(descriptor.group) ?? [];
        bucket.push(descriptor);
        map.set(descriptor.group, bucket);
    }
    return Array.from(map.entries()).map(([group, items]) => ({
        title: props.labels[group] ?? group,
        rows: items.map((item) => ({ keys: [item.keys], label: item.label })),
    }));
});

// While the legend is open the parent registry is inactive, so it owns Esc / "?"
// to dismiss itself without the underlying modal also reacting.
onKeyStroke(['Escape', '?'], (e) => {
    if (e.repeat) return;
    if (!props.show) return;
    e.preventDefault();
    emit('close');
});
</script>
